import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { subscribeToBrand, subscribeToList } from 'apis/mafia';
import { trackError } from 'helpers/ErrorUtils';

export function subscribeToBrandNotification(emailAddress, brandId) {
  return (dispatch, getState) => {
    const state = getState();
    const { cookies, environmentConfig: { api: { mafia } } } = state;

    return subscribeToBrand(mafia, {
      emailAddress,
      brandIds: [brandId]
    }, cookies)
      .then(fetchErrorMiddleware)
      .then(() => true)
      .catch(e => {
        trackError('NON-FATAL', 'Could not subscribe to brand notifications.', e);
      });
  };
}

export function subscribeToLandingList(emailAddress, listId) {
  return (dispatch, getState) => {
    const state = getState();
    const subsiteId = 1;
    const { cookies, environmentConfig: { api: { mafia } } } = state;
    return subscribeToList(mafia, {
      subsiteId,
      emailAddress,
      listIds: [listId]
    }, cookies)
      .then(fetchErrorMiddleware)
      .then(() => true)
      .catch(e => {
        trackError('NON-FATAL', 'Could not subscribe to list.', e);
      });
  };
}
